// Best-effort copy to the system clipboard. Resolves to whether the write
// succeeded so callers can surface a toast/feedback; never throws.
export const copyToClipboard = async (text: string): Promise<boolean> => {
  if (!text) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
